import React from 'react';
import cn from 'classnames';
import styles from './NavigationList.module.scss';

export const NavigationList = ({ data, onClick, activeItem }) => (
  <ul className={styles.navigationList}>
    { data.map(child => (
      <li key={child.value} className={cn(activeItem === child.value.toLowerCase() ? styles.item_active : styles.item)}>
        <span onClick={() => onClick(child.value)} value={child.value}>
          { child.label }
        </span>
      </li>
    ))}
  </ul>
);
